module.exports = __webpack_public_path__ + "static/media/sf-test-8.d0c5fbcf.mp3";